import React, { forwardRef } from 'react';

interface LoadingSpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: string;
  spinnerWidth?: string;
  baseColour?: string;
  spinnerColour?: string;
}

const LoadingSpinner = forwardRef<HTMLDivElement, LoadingSpinnerProps>(
  (
    {
      size = '2rem',
      spinnerWidth = '0.4rem',
      baseColour = 'white',
      spinnerColour = '#0a57ff',
      className = '',
      ...props
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={`rounded-full animate-spin mx-auto ${className}`}
        style={{
          height: size,
          width: size,
          borderWidth: spinnerWidth,
          borderColor: baseColour,
          borderTopColor: spinnerColour,
          borderStyle: 'solid',
        }}
        {...props}
      />
    );
  },
);

LoadingSpinner.displayName = 'LoadingSpinner';

export default LoadingSpinner;
